import {hexColorToRGBA} from '@/views/chart/chart/util'
import {componentStyle} from '../common/common'
import {BASE_ECHARTS_SELECT, DEFAULT_TOOLTIP} from '@/views/chart/chart/chart'
import {valueFormatterWithoutSuffix} from "@/views/chart/chart/formatter";
import { getStrByLang } from '@/utils'

export function basePieOption(chart_option, chart) {
  // 处理shape attr
  let customAttr = {}
  if (chart.customAttr) {
    customAttr = JSON.parse(chart.customAttr)
    if (customAttr.color) {
      chart_option.color = customAttr.color.colors
    }
    // tooltip
    if (customAttr.tooltip) {
      const tooltip = JSON.parse(JSON.stringify(customAttr.tooltip))
      const reg = new RegExp('\n', 'g')
      tooltip.formatter = tooltip.formatter.replace(reg, '<br/>')
      chart_option.tooltip = tooltip

      const bgColor = tooltip.backgroundColor ? tooltip.backgroundColor : DEFAULT_TOOLTIP.backgroundColor
      chart_option.tooltip.backgroundColor = bgColor
      chart_option.tooltip.borderColor = bgColor
    }
  }
  // 处理data
  if (chart.data) {
    chart_option.title.text = getStrByLang(chart.title)
    if (chart.data.series.length > 0) {
      chart_option.series[0].name = getStrByLang(chart.data.series[0].name)
      chart_option.series[0].selectedMode = true
      chart_option.series[0].select = BASE_ECHARTS_SELECT
      // size
      if (customAttr.size) {
        chart_option.series[0].radius = [customAttr.size.pieInnerRadius + '%', customAttr.size.pieOuterRadius + '%']
      }
      // label
      if (customAttr.label) {
        chart_option.series[0].label = customAttr.label
        chart_option.series[0].labelLine = customAttr.label.labelLine
      }
      const valueArr = chart.data.series[0].data
      for (let i = 0; i < valueArr.length; i++) {
        const y = valueArr[i]
        let name=chart.data.x[i]
        name=getStrByLang(name)
        y.name = name

        formatValue(y, chart)
        // color
        y.itemStyle = {
          color: hexColorToRGBA(customAttr.color.colors[i % customAttr.color.colors.length], customAttr.color.alpha),
          borderRadius: 0
        }
        y.type = 'pie'
        chart_option.series[0].data.push(y)
      }
    }
  }
  console.log("aaaaa-----")
  console.log(chart)
  componentStyle(chart_option, chart)
  return chart_option
}

export function rosePieOption(chart_option, chart) {


  // 处理shape attr
  let customAttr = {}
  if (chart.customAttr) {
    customAttr = JSON.parse(chart.customAttr)
    if (customAttr.color) {
      chart_option.color = customAttr.color.colors
    }
    // tooltip
    if (customAttr.tooltip) {
      const tooltip = JSON.parse(JSON.stringify(customAttr.tooltip))
      const reg = new RegExp('\n', 'g')
      tooltip.formatter = tooltip.formatter.replace(reg, '<br/>')
      chart_option.tooltip = tooltip
      const bgColor = tooltip.backgroundColor ? tooltip.backgroundColor : DEFAULT_TOOLTIP.backgroundColor
      chart_option.tooltip.backgroundColor = bgColor
      chart_option.tooltip.borderColor = bgColor
    }
  }
  // 处理data
  if (chart.data) {
    chart_option.title.text = getStrByLang(chart.title)
    if (chart.data.series.length > 0) {
      chart_option.series[0].name = getStrByLang(chart.data.series[0].name)
      chart_option.series[0].selectedMode = true
      chart_option.series[0].select = BASE_ECHARTS_SELECT
      // size
      if (customAttr.size) {
        chart_option.series[0].radius = [customAttr.size.pieInnerRadius + '%', customAttr.size.pieOuterRadius + '%']
        chart_option.series[0].roseType = customAttr.size.pieRoseType
      }
      // label
      if (customAttr.label) {
        chart_option.series[0].label = customAttr.label
      }
      const valueArr = chart.data.series[0].data
      for (let i = 0; i < valueArr.length; i++) {
        const y = valueArr[i]
        y.name = chart.data.x[i]
        formatValue(y, chart)
        // color
        y.itemStyle = {
          color: hexColorToRGBA(customAttr.color.colors[i % customAttr.color.colors.length], customAttr.color.alpha),
          borderRadius: customAttr.size.pieRoseRadius
        }
        y.type = 'pie'
        chart_option.series[0].data.push(y)
      }
    }
  }

  componentStyle(chart_option, chart)
  return chart_option
}


/**
 * 根据选中的数值格式统一格式化处理数据
 * @param y
 * @param chart
 */
const formatValue = (y, chart) => {
  let yAxis = []
  try {
    yAxis = JSON.parse(chart.yaxis)
  } catch (err) {
    yAxis = JSON.parse(JSON.stringify(chart.yaxis))
  }
  const f = (yAxis && yAxis.length > 0) ? yAxis[0] : null
  if (f && f.formatterCfg) {
    if (!y.isFormat) {
      // 不在末尾添加千、万、亿等中文符号，否则数值无法正确渲染
      const v = valueFormatterWithoutSuffix(y.value, f.formatterCfg)
      y.value = v.includes('NaN') ? y.value : v
      y.isFormat = true
    }
  }
  y.value = y.value.replace(/,/g, "")
}
